import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FiLock, FiUser, FiArrowRight, FiShield, FiFileText, 
  FiBarChart2, FiUsers, FiBriefcase, FiHome, FiDroplet,
  FiGlobe, FiTrendingUp, FiPieChart, FiAward 
} from 'react-icons/fi';
import './InvestorPortal.css';

const InvestorPortal = () => {
  const portalCategories = [
    {
      id: 'energy',
      title: 'Energy & Oil',
      description: 'Upstream, midstream, and downstream opportunities across global energy markets',
      icon: <FiDroplet />,
      color: '#ff6b35',
    
      features: ['Production Sharing Agreements', 'Exploration Rights', 'LNG Infrastructure', 'Refinery Projects']
    },
    {
      id: 'commodities',
      title: 'Commodities & Mining',
      description: 'Strategic minerals, metals, and commodity trading opportunities',
      icon: <FiBarChart2 />,
      color: '#4ecdc4',
   
      features: ['Rare Earth Elements', 'Base Metals', 'Offtake Agreements', 'Mining Acquisitions']
    },
    {
      id: 'realestate',
      title: 'Real Estate',
      description: 'Commercial, industrial, and mixed-use development opportunities',
      icon: <FiHome />,
      color: '#f7b731',
    
      path: '/investor-portal/realestate',
      features: ['Office Portfolios', 'Mixed-Use Developments', 'Industrial Assets', 'Land Banks']
    },
    {
      id: 'jointventures',
      title: 'Joint Ventures',
      description: 'Strategic partnerships and co-investment opportunities',
      icon: <FiUsers />,
      color: '#a55eea',
 
      path: '/investor-portal/jointventures',
      features: ['Cross-Border JVs', 'Infrastructure Partnerships', 'Fund Co-Investments', 'Strategic Alliances']
    },
  
  
  ];

  const featuredOpportunities = [
    {
      sector: 'Energy & Oil',
     
      icon: <FiDroplet />
    },
    {
      sector: 'Commodities & Mining',
    
      icon: <FiBarChart2 />
    },
    {
      sector: 'Real Estate',
    
      icon: <FiHome />
    },
    {
      sector: 'Joint Ventures',
   
      icon: <FiUsers />
    }
  ];

  const portalFeatures = [
    {
      icon: <FiFileText />,
      title: 'Deal Flow',
      description: 'Access to curated investment opportunities and transaction documentation'
    },
    {
      icon: <FiBarChart2 />,
      title: 'Market Intelligence',
      description: 'Exclusive market insights and sector analysis'
    },
    {
      icon: <FiUsers />,
      title: 'Network Access',
      description: 'Connect with verified counterparties and partners'
    },
    {
      icon: <FiShield />,
      title: 'Secure Environment',
      description: 'End-to-end encrypted communications and document sharing'
    }
  ];
  return (
    <div className="investor-portal">
      {/* Hero Section */}
      <section className="portal-hero">
        <div className="container">
          <h1 className="portal-hero-title">Investor Portal</h1>
          <p className="portal-hero-subtitle">
            Access exclusive investment opportunities, market intelligence, and transaction 
            documentation across global energy, commodities, real estate, and joint ventures.
          </p>
        </div>
      </section>
     
      {/* Investment Categories Grid */}
      <section className="categories-section">
        <div className="container">
          <h2 className="section-title center">Investment Categories</h2>
          <p className="section-subtitle center">
            Explore opportunities by sector and investment type
          </p>
          <div className="categories-grid">
            {portalCategories.map((category, index) => (
              <Link to={category.path} key={index} className="category-card-wrapper">
                <div className="category-card" style={{ borderTopColor: category.color }}>
                  <div className="category-icon" style={{ background: `linear-gradient(135deg, ${category.color}20, ${category.color}40)` }}>
                    {category.icon}
                  </div>
                  <h3 className="category-title">{category.title}</h3>
                  <p className="category-description">{category.description}</p>
                  <div className="category-stats">
                    <span className="category-stat">{category.opportunities}</span>
                    <span className="category-stat">{category.volume}</span>
                  </div>
                  <div className="category-features">
                    {category.features.slice(0, 3).map((feature, i) => (
                      <span key={i} className="feature-tag">{feature}</span>
                    ))}
                  </div>
                  <div className="category-footer">
                  
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

     

      

      
      {/* Security Notice */}
      <section className="security-section">
        <div className="container">
          <div className="security-notice">
            <FiShield className="security-icon" />
            <div className="security-content">
              <h3>Secure Portal Access</h3>
              <p>
                Access to deal flow, market intelligence, and transaction documentation is restricted 
                to verified clients and institutional counterparties. The portal provides a secure 
                environment for confidential communications and transaction coordination.
              </p>
              <p className="security-small">
                All data is encrypted using enterprise-grade security protocols. Two-factor authentication 
                is available and recommended for all users.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default InvestorPortal;